import Empty from '../../components/empty/Empty'

import './pages.css'

const Friend = ({isCurrent, data}) => {

      if(isCurrent !== 'friend') return 

      if(data.data){
            return (
                  <div className={isCurrent === 'friend' ? "content_page show" : "content_page"}>
                        <Empty text={`Not Found Friends`}/>
                  </div>
            )
      }

      return (
            <div className={isCurrent === 'friend' ? "content_page show" : "content_page"}>
                  <div className="content_page__inner">
                        <div className="friend_content">
                              {
                                    data.map((item, index) => (
                                          <div className="friend_row" key={index}>
                                                <div className="friend_row__avatar">
                                                      <img src={item.avatar === '' ? `https://api.dicebear.com/5.x/initials/svg?seed=${item.name}&font-size=26` : item.avatar}
                                                            alt={item.name}
                                                      />
                                                </div>
                                                <div className="friend_row__data">
                                                      <strong>{item.name}</strong>
                                                      <p>{item.description}</p>
                                                      <a href={item.me} target="_blank" rel="noreferrer">xat.me</a>
                                                </div>
                                          </div>
                                    ))
                              }
                              
                        </div>
                  </div>
            </div>
      )

}

export default Friend
